import { Alert, Button } from '@evaneos/b2b-ui/legacy';
import { useIntl } from 'react-intl';

import { DossierId } from '../../../../resources/dossier/types';
import { removePreTripReview } from '../../../../resources/pre-trip-review';
import { PreTripReview } from '../../../../resources/pre-trip-review/types';
import { useGetTrackedTripProperties, useTrackEventAmplitude } from '../../../../shared/analytics';
import { useAppDispatch } from '../../../../shared/redux';

import s from './AlertReview.module.css';

type Props = {
    preTripReview: PreTripReview;
    dossierId: DossierId;
};

export const AlertPreTripReview = ({ preTripReview, dossierId }: Props): JSX.Element => {
    const intl = useIntl();
    const dispatch = useAppDispatch();
    const { trackEvent } = useTrackEventAmplitude();
    const trackedTripProperties = useGetTrackedTripProperties(dossierId);

    const handleHideReviewClick = () => {
        dispatch(removePreTripReview(dossierId));
        trackEvent((ampli, defaultProperties) => {
            ampli.hideFeedbackClicked({
                ...defaultProperties,
                ...trackedTripProperties,
            });
        });
    };

    return (
        <Alert
            collapsible={true}
            type={preTripReview.isTravelerSatisfied ? 'information' : 'warning'}
            title={intl.formatMessage(
                {
                    id: preTripReview.isTravelerSatisfied
                        ? 'dossier.pre_trip_review.title.positive'
                        : 'dossier.pre_trip_review.title.negative',
                },
                {
                    createdAt:
                        preTripReview.createdAt &&
                        preTripReview.createdAt.toLocaleDateString(undefined, {
                            year: 'numeric',
                            month: 'short',
                            day: 'numeric',
                        }),
                },
            )}
            showContentByDefault={false}
            data-testid="pre-trip-review"
        >
            <p>
                {intl.formatMessage(
                    {
                        id: 'dossier.pre_trip_review.feelings_about_agent_relationship',
                    },
                    {
                        feelingsAboutAgentRelationship: (
                            <strong>{preTripReview.feelingsAboutAgentRelationship}</strong>
                        ),
                    },
                )}
            </p>
            {preTripReview.moreAboutAgentRelationship && (
                <p>&quot;{preTripReview.moreAboutAgentRelationship}&quot;</p>
            )}
            <Button
                className={s.hideReviewButton}
                danger
                priority="secondary"
                onClick={handleHideReviewClick}
            >
                {intl.formatMessage({ id: 'dossier.trip_reviews.button' })}
            </Button>
        </Alert>
    );
};
